import { useQuery } from '@apollo/client'
import { Skeleton } from '@mui/material'
import { CSSProperties } from 'react'

import {
  GET_SIMPLE_PRODUCT,
  GetSimpleProductQuery,
  GetSimpleProductQueryVariables,
} from '@/graphql'

export const ProductImage = ({
  upc,
  imageUrl: imageUrlProp,
  skeleton,
  ...styles
}: {
  upc?: string
  imageUrl?: string | null
  skeleton?: boolean
} & CSSProperties) => {
  const { data } = useQuery<
    GetSimpleProductQuery,
    GetSimpleProductQueryVariables
  >(GET_SIMPLE_PRODUCT, {
    variables: { upc: upc! },
    skip: imageUrlProp !== undefined || !upc,
  })
  const image =
    imageUrlProp !== undefined ? imageUrlProp : data?.product?.marketingImageUrl
  const style = {
    ...styles,
    width: styles.width || '40px',
    height: styles.height || '40px',
    borderRadius: '4px',
  }
  return image ? (
    <img src={image} alt={upc} style={style} />
  ) : skeleton ? (
    <Skeleton
      variant="rounded"
      width={style.width}
      height={style.height}
      sx={{ borderRadius: style.borderRadius, flexShrink: 0 }}
    />
  ) : null
}
